import { render, staticRenderFns } from "./OrderConfirmed.vue?vue&type=template&id=7004c499&"
import script from "./OrderConfirmed.vue?vue&type=script&lang=js&"
export * from "./OrderConfirmed.vue?vue&type=script&lang=js&"
import style0 from "./OrderConfirmed.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports